export default {
  data() {
    return {
      maxWorksOnPage: 20,//WorksListMix
      pushWorks     : false,
      T: null,
      inited:false,
    }
  },
  methods : {
    prevPage(pushWorks, event) {
      if (event) {
        event.preventDefault()
      }

      if (this.currentPage > 1) {
        this.changePage(this.currentPage - 1, pushWorks)
      }
    },
    nextPage(pushWorks, event) {
      if (event) {
        event.preventDefault()
      }

      if (this.currentPage < this.lastPage) {
        this.changePage(this.currentPage + 1, pushWorks)
      }
    },
    changePage(page, pushWorks, event) {
      if (event) {
        event.preventDefault();
      }

      //фиксируем высоту блока с работами, чтобы при перерисовке страница не прыгала
      $('#id_main_works_list').css('height', $('#id_main_works_list').css('height'));

      this.pushWorks   = pushWorks;
      this.currentPage = page;
    },
    onResize(){
      clearTimeout( this.T );
      let this_=this;
      this.T=setTimeout( function(){
        let is_refresh=false;
        let j=$('#id_pager');

        j.css('width', '100%');

        let j_lis=$('li', j);
        let w=0;
        let is_add=true;
        j_lis.each( function(n,o){
          let j_li=$(o);
          let left=j_li.position().left;
          if ( j_li.position().left<0 ) is_refresh=true;

          if ( left==0 && n>0 ) is_add=false;
          if (is_add){
            w+=j_li.outerWidth(true);
          }
        } );

        if (w>0) j.css('width', w+'px');

        if ( is_refresh ) this_.onResize();
      }, 250 );
    }
  },
  computed: {
    currentPage    : {
      get() {
        let c=parseInt(this.$store.getters.filters.p);
        if ( c==null || isNaN(c) ) c=1;
        return c;
      },
      set(value) {
        this.$store.dispatch('setPushWorks', this.pushWorks).then(() => {
          this.$store.dispatch('setFilters', {p: value.toString(), scroll:!this.pushWorks}).then(()=>{})
        })
      }
    },
    worksTotal     : {
      get() {
        return parseInt(this.$store.getters.worksTotal);
      },
    },
    lastPage       : {
      get() {
        return Math.ceil(this.worksTotal / this.maxWorksOnPage)
      },
    },
    worksOnNextPage: {
      get() {
        if (this.currentPage === this.lastPage) {
          return false
        } else if (this.lastPage - this.currentPage === 1) {
          return this.worksTotal % this.maxWorksOnPage
        }

        return this.maxWorksOnPage
      }
    },
    snowFirst      : function () {
      return this.minPage > 2;
    },
    snowLast       : function () {
      return this.maxPage < this.lastPage
    },

    minPage          : function () {
      let minPage=this.currentPage-3;
      let maxPage=this.currentPage+3;

      while (minPage<1){
        minPage++;
        maxPage++;
      }

      while (maxPage>this.lastPage){
        maxPage--;
        if (minPage>1) minPage--;
      }

      return minPage;
    },

    maxPage          : function () {
      let minPage=this.currentPage-3;
      let maxPage=this.currentPage+3;

      while (minPage<1){
        minPage++;
        maxPage++;
      }

      while (maxPage>this.lastPage){
        maxPage--;
        if (minPage>1) minPage--;
      }

      return maxPage;
    },


    range : function () {
      let range = [];
      for (let i = this.minPage; i <= this.maxPage; i++) {
        if (this.snowFirst && i==1) continue;
        range.push(i);
      }

      return range;
    },
  },

  updated() {
    this.$nextTick(function () {
      this.onResize();

      if (this.inited) return;
      this.inited=true;
      window.addEventListener('resize', this.onResize);
    });
  },

}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/WorksPaginationMix.js
// module id = null
// module chunks = 